(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundles-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundles-picker')) {
    class BundlesPicker extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-bundles-track]');
        this.slides = Array.from(this.querySelectorAll('[data-bundles-slide]'));
        this.pills = Array.from(this.querySelectorAll('[data-bundles-pill]'));
        this.details = Array.from(this.querySelectorAll('[data-bundles-detail]'));
        this.pillsList = this.querySelector('[data-bundles-pills]');
        this.index = 0;
        if (!this.track || this.slides.length === 0) return;

        this.onScroll = this.handleScroll.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.onBlockSelect = this.handleBlockSelect.bind(this);

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.pills.forEach((pill) => {
          pill.addEventListener('click', () => {
            this.goTo(Number(pill.dataset.index));
          });
        });
        this.pillsList?.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.pillsList?.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      goTo(index) {
        const slide = this.slides[index];
        if (!slide) return;
        this.programmatic = true;
        slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        this.setActive(index);
        window.setTimeout(() => {
          this.programmatic = false;
        }, 450);
      }

      handleScroll() {
        if (this.programmatic) return;
        const origin = this.track.getBoundingClientRect().left;
        let closest = 0;
        let closestDist = Infinity;
        this.slides.forEach((slide, i) => {
          const dist = Math.abs(slide.getBoundingClientRect().left - origin);
          if (dist < closestDist) {
            closestDist = dist;
            closest = i;
          }
        });
        if (closest !== this.index) this.setActive(closest);
      }

      handleKeydown(event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const next = event.key === 'ArrowRight' ? this.index + 1 : this.index - 1;
        const bounded = Math.max(0, Math.min(this.slides.length - 1, next));
        this.goTo(bounded);
        this.pills[bounded]?.focus();
      }

      handleBlockSelect(event) {
        if (!this.contains(event.target)) return;
        const slide = event.target.closest('[data-bundles-slide]');
        if (!slide) return;
        this.goTo(Number(slide.dataset.index));
      }

      setActive(index) {
        this.index = index;
        this.pills.forEach((pill, i) => {
          const selected = i === index;
          pill.classList.toggle('is-active', selected);
          pill.setAttribute('aria-selected', selected ? 'true' : 'false');
          pill.tabIndex = selected ? 0 : -1;
        });
        this.details.forEach((detail, i) => {
          detail.hidden = i !== index;
        });
      }
    }

    customElements.define('bundles-picker', BundlesPicker);
  }
  } catch(e) { console.error(e); }
})();

})();
